/**
 * フロント側で使用する有効な年に関する定義
 */
export namespace SystemYear {
  /** システムで使用可能な最小の年(基本はシステム稼働年) */
  export const SYSTEM_MIN_YEAR = 2024

  /**
   * 現在年を基準にした年リストを取得する(年は古い順となる)
   *
   * @param pastCount 過去年を取得する件数 0の場合は現在年から取得され、1以上ならその分だけ過去年を取得する
   * @param futureCount 未来年を取得する件数 0の場合は現在年までを取得し、1以上ならその分だけ未来年を取得する
   * @returns 有効な年のリスト
   */
  export function yearList(pastCount: number, futureCount: number): number[] {
    // 現在年を取得
    const nowDate = new Date()
    const nowYear = nowDate.getFullYear()

    // 取得開始する年を計算
    let minYear = nowYear - pastCount
    // システム利用可能な最小年より前となる場合は補正
    if (minYear < SYSTEM_MIN_YEAR) {
      minYear = SYSTEM_MIN_YEAR
    }

    // 取得件数を計算
    //   現在年 - 最小年 = 過去年の取得件数
    //   過去年の取得件数 + 未来年の取得件数 + 現在年(1) = 取得件数
    const listSize = nowYear - minYear + futureCount + 1

    // ループで年の配列を作成
    const years = []
    for (let i = 0; i < listSize; i++) {
      years.push(minYear + i)
    }

    return years
  }
}
